import { Bell, ClipboardList, ListOrdered, Store, Timer, Users } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const spaConfig: LandingConfig = {
  slug: 'spa',
  namespace: 'landing-spa',
  analyticsId: 'for-spa',
  canonicalPath: '/for-spa',
  ogImagePath: '/images/og-spa.jpg',
  heroImage: '/images/hero-spa',
  // Order matches landing-spa:features.items[]
  featureIcons: [Store, Bell, Users, Timer, ClipboardList, ListOrdered],
  comparison: VERTICAL_COMPARISON,
};
